import React from 'react';
import Column from '../../column';
import Text from './text';
import Block from './block';

const Company = ({
  className,
  columnWidth,
  align,
  justify,
  order,
  offset,
  card,
  title,
  variant,
  ...props
}) => {
  const Component = variant === 'block' ? Block : Text;
  return (
    <Column
      className={className}
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      card={card}
      order={order}
      offset={offset}
    >
      <Component
        columnWidth={columnWidth}
        justify={justify}
        title={title}
        {...props}
      />
    </Column>
  );
};

export default Company;
